// extracted by mini-css-extract-plugin
export default {"phoneInput":"userProfile_phoneInput__RD1jg","inputBox":"userProfile_inputBox__nqLcX"};